import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { convertPxToNumber } from '../../../constants/helpers/utils';

interface WindowSize {
  width: number;
  height: number;
}

function useWindowSize(): WindowSize {
  const theme = useTheme();
  const isMediumBreakpoint = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0
  });
  useEffect(() => {
    const handler = () => {
      const minScreenHeight =
        convertPxToNumber(theme.pageLayout.content.minHeight) + convertPxToNumber(theme.pageLayout.header.height);
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight < minScreenHeight && isMediumBreakpoint ? minScreenHeight : window.innerHeight
      });
    };

    // Set size at the first client-side load
    handler();

    window.addEventListener('resize', handler);

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return windowSize;
}

export default useWindowSize;
